import React from "react";
import { Alert, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import { LuRectangleEllipsis } from "react-icons/lu";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ReactFancyBox from "react-fancybox";
const Item = ({
  item,
  moduleConfig,
  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
  confirmAndDelete,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    items.push(
      { text: "Button Text", value: item.buttonText, type: "text" },
      { text: "Button Link", value: item.buttonLink, type: "link" },
      { text: "Button Color", value: item.buttonColor, type: "color" },
      { text: "Button Text Color", value: item.buttonTextColor, type: "color" },
      { text: "Heading Color", value: item.headingColor, type: "color" },
      { text: "Background Color", value: item.backgroundColor, type: "color" }
    );
    if (item.sortOrder) {
      items = [
        ...items,
        {
          text: "Sort Order",
          value: item.sortOrder,
          type: "number",
        },
      ];
    }
    return items;
  };
  return (
    <Card className="item mb-2 borderCream position-relative">
      {(item.status === "0" || item.status === 0) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.2)",
            width: "100%",
            height: "100%",
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            backdropFilter: "blur(1px)",
            borderRadius: "inherit",
          }}
        >
         
        </div>
      )}

      {/* {console.log(item)} */}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex align-items-center ImageSectionSpacing">
            <div className="checkboxCol me-2 mt-2"></div>

            <div className="ms-1 me-2 position-relative userIcon">
              <ReactFancyBox
                thumbnail={
                  process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                }
                image={
                  process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                }
                caption={`${item.heading1} ${item.heading2}`}
              />
            </div>

            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                {item.heading}
              </span>

              {/* <span className=" fs-8  ">
                <span className="text-custom-4 mt-1 small  text-bold">
                  {item.buttonText}
                </span>
              </span> */}
            </div>
          </div>
        </Card.Title>

        <div
          className="card-tools endColumn mb-1 pt-1"
          style={{ zIndex: 101, position: "relative" }}
        >
          <div>
            <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span className="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>
            {item.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}

            <span
              title={`Delete ${moduleConfig.singleItemTitle}`}
              onClick={() => confirmAndDelete(item._id)}
              className="btn btn-outline-secondary listingActionIcon"
            >
              <i className="fas fa-trash"></i>
            </span>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col className="mt-1 mb-1 ">
            <StatsListing items={getItems()} />
          </Col>
          {/* <Col md={2} className="text-center cursor-pointer py-1">
            <ReactFancyBox
              thumbnail={
                process.env.REACT_APP_BACKEND_URL + "public/" + item.image
              }
              image={process.env.REACT_APP_BACKEND_URL + "public/" + item.image}
              caption={`${item.heading}`}
            />
            
          </Col> */}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Item;
